module.exports = __webpack_public_path__ + "static/img/vrroad_function04.a1e22a58.png";